module.exports = __webpack_public_path__ + "static/img/img_intro_invite.c140238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_intro_invite.png
// module id = XU2M
// module chunks = 1